export enum EPrivileges {
  GENERAL_WRITE_PRIVILEGE = "GENERAL_WRITE_PRIVILEGE",
  GENERAL_READ_PRIVILEGE = "GENERAL_READ_PRIVILEGE",
  DASHBOARD_READ_PRIVILEGE = "DASHBOARD_READ_PRIVILEGE",
  DASHBOARD_WRITE_PRIVILEGE = "DASHBOARD_WRITE_PRIVILEGE",
  DEVICE_READ_PRIVILEGE = "DEVICE_READ_PRIVILEGE",
  DEVICE_WRITE_PRIVILEGE = "DEVICE_WRITE_PRIVILEGE",
  CONTROLLER_READ_PRIVILEGE = "CONTROLLER_READ_PRIVILEGE",
  CONTROLLER_WRITE_PRIVILEGE = "CONTROLLER_WRITE_PRIVILEGE",
  SCHEDULE_READ_PRIVILEGE = "SCHEDULE_READ_PRIVILEGE",
  SCHEDULE_WRITE_PRIVILEGE = "SCHEDULE_WRITE_PRIVILEGE",
  MONITORING_READ_PRIVILEGE = "MONITORING_READ_PRIVILEGE",
  MONITORING_WRITE_PRIVILEGE = "MONITORING_WRITE_PRIVILEGE",
  GENERATION_READ_PRIVILEGE = "GENERATION_READ_PRIVILEGE",
  GENERATION_WRITE_PRIVILEGE = "GENERATION_WRITE_PRIVILEGE",
  USAGE_GUIDE_READ_PRIVILEGE = "USAGE_GUIDE_READ_PRIVILEGE",
  USAGE_GUIDE_WRITE_PRIVILEGE = "USAGE_GUIDE_WRITE_PRIVILEGE",
  USER_MANAGEMENT_READ_PRIVILEGE = "USER_MANAGEMENT_READ_PRIVILEGE",
  USER_MANAGEMENT_WRITE_PRIVILEGE = "USER_MANAGEMENT_WRITE_PRIVILEGE",
  EXTERNAL_GENERATION_READ_PRIVILEGE = "EXTERNAL_GENERATION_READ_PRIVILEGE",
  EXTERNAL_GENERATION_WRITE_PRIVILEGE = "EXTERNAL_GENERATION_WRITE_PRIVILEGE",
  ONLY_EXTERNAL_GENERATION_WRITE_PRIVILEGE = "ONLY_EXTERNAL_GENERATION_WRITE_PRIVILEGE",
  ONLY_EXTERNAL_GENERATION_READ_PRIVILEGE = "ONLY_EXTERNAL_GENERATION_READ_PRIVILEGE",
  BILL_ESTIMATOR_READ_PRIVILEGE = "BILL_ESTIMATOR_READ_PRIVILEGE",
  BILL_ESTIMATOR_WRITE_PRIVILEGE = "BILL_ESTIMATOR_WRITE_PRIVILEGE",
  LIFE_LINE_POWER_READ_PRIVILEGE = "LIFE_LINE_POWER_READ_PRIVILEGE",
  LIFE_LINE_POWER_WRITE_PRIVILEGE = "LIFE_LINE_POWER_WRITE_PRIVILEGE",
  POWER_LIMIT_READ_PRIVILEGE = "POWER_LIMIT_READ_PRIVILEGE",
  POWER_LIMIT_WRITE_PRIVILEGE = "POWER_LIMIT_WRITE_PRIVILEGE",
  BLACKOUT_READ_PRIVILEGE = "BLACKOUT_READ_PRIVILEGE",
  BLACKOUT_WRITE_PRIVILEGE = "BLACKOUT_WRITE_PRIVILEGE",
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_SOLAR_DASHBOARD_ADMIN = "ROLE_SOLAR_DASHBOARD_ADMIN",
}
